module.exports = __webpack_public_path__ + "static/media/simplestockview.ce7da5a0.png";